import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { stardardRequest } from '../../utils';
import { API_BASE } from '../../constants/api.constant'

import {
  LEADS_FETCH,
  LEADS_SET_FILTERS,
  LEADS_FETCH_BY_ID,
  LEADS_ADD,
  LEADS_EDIT,
  LEADS_DELETE,
  LEADS_MARK_PROCESSED,
  LEADS_INCIDENT_PIE_CHART
} from '../actions';

export function* watchLeadFetchRequest() {
  const action = LEADS_FETCH
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      const filters = state.leads.grid_options.lead.filters||{}
      const data = {...filters, ...payload}
      const { mode, ...post } = data
      return {
        method: 'post',
        url: `${API_BASE}/incidents`,
        data: post
      }
    },
    dataPath: 'incidents',
    dataDefault: [],
  }));
}

export function* watchLeadFiltersRequest() {
  yield takeEvery(LEADS_SET_FILTERS.REQUEST, function* ({ payload }) {
    yield put(LEADS_FETCH.requestAction({}))
    yield put(LEADS_INCIDENT_PIE_CHART.requestAction({}))
  })
}

export function* watchLeadFetchIdRequest() {
  const action = LEADS_FETCH_BY_ID
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      return {
        method: 'get',
        url: `${API_BASE}/incidents/${payload.id}`
      }
    },
    dataPath: 'incident',
    dataDefault: [],
  }));
}

export function* watchLeadAddRequest() {
  const action = LEADS_ADD
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      console.log(payload,'payload')
      return {
        method: 'post',
        url: `${API_BASE}/incident`,
        data: payload
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export function* watchLeadEditRequest() {
  const action = LEADS_EDIT
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      return {
        method: 'patch',
        url: `${API_BASE}/incident/${payload.id}`,
        data: payload
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export function* watchLeadDeleteRequest() {
  const action = LEADS_DELETE
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      return {
        method: 'delete',
        url: `${API_BASE}/incident/${payload.id}`
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export function* watchLeadMarkProcessedRequest() {
  const action = LEADS_MARK_PROCESSED
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      return {
        method: 'post',
        url: `${API_BASE}/incident/${payload.id}/processed`
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export function* watchLeadIncidentPieChartRequest() {
  const action = LEADS_INCIDENT_PIE_CHART
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      const filters = state.leads.grid_options.lead.filters||{}
      const data = {...filters, ...payload}
      const { mode, ...post } = data
      return {
        method: 'post',
        url: `${API_BASE}/incident/chart/incident-type`,
        data: post
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export default function* rootSaga() {
  yield all([
    fork(watchLeadFetchRequest),
    fork(watchLeadFiltersRequest),
    fork(watchLeadFetchIdRequest),
    fork(watchLeadAddRequest),
    fork(watchLeadEditRequest),
    fork(watchLeadDeleteRequest),
    fork(watchLeadMarkProcessedRequest),
    fork(watchLeadIncidentPieChartRequest),
  ]);
}